import { z } from 'zod';
import { ThemingFontDefSchema } from '~schemas/settings';

export const BrandingColoursSchema = z.object({
  brand: z.object({
    primary: z.string(),
    surface: z.string(),
  }),
  text: z.object({
    heading: z.string(),
    body: z.string(),
  }),
});

export const BrandingFontsSchema = z.object({
  heading: ThemingFontDefSchema,
  body: ThemingFontDefSchema,
});

export const BrandingAssetsSchema = z.object({
  logo: z.object({ url: z.string() }).nullable().optional(),
  banner: z.object({ url: z.string() }).nullable().optional(),
});

export const BrandingSchema = z.object({
  colours: BrandingColoursSchema,
  fonts: BrandingFontsSchema,
  assets: BrandingAssetsSchema.nullable().optional(),
  dark_mode: z.boolean().default(false),
});

export type Branding = z.infer<typeof BrandingSchema>;
